import { render, staticRenderFns } from "./WabaSupsisBusinessPrimaryLocationCountryUpdate.vue?vue&type=template&id=c2358e2a&scoped=true"
import script from "./WabaSupsisBusinessPrimaryLocationCountryUpdate.vue?vue&type=script&lang=js"
export * from "./WabaSupsisBusinessPrimaryLocationCountryUpdate.vue?vue&type=script&lang=js"
import style0 from "./WabaSupsisBusinessPrimaryLocationCountryUpdate.vue?vue&type=style&index=0&id=c2358e2a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2358e2a",
  null
  
)

export default component.exports